<template>
  <v-card class="card-border" max-width="800">
    <v-card-title class="justify-center">Rank de Consorcio</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        sort-by="posicaoConsorcio"
        hide-default-footer
        :items-per-page="10"
      >
        <template v-slot:item.variacaoConsorcio="{ item }">
          <v-btn icon v-if="item.variacaoConsorcio > 0">
            <v-icon color="#75C00E">mdi-arrow-up-bold</v-icon>
            +{{ item.variacaoConsorcio }}
          </v-btn>
          <v-btn icon v-else-if="item.variacaoConsorcio < 0">
            <v-icon color="#DB2832">mdi-arrow-down-bold</v-icon>
            {{ item.variacaoConsorcio }}
          </v-btn>
        </template>

        <template v-slot:item.posicaoConsorcio="{ item }">{{ item.posicaoConsorcio }}ª</template>

        <template v-slot:footer>
          <v-row justify="center">
            <v-col cols="1">
              <v-btn
                outlined
                color="blue darken-2"
                rounded
                dark
                depressed
                small
                @click="$refs.dialogRankConsorcio.show(items)"
              >Expandir</v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card-text>
    <DialogRankConsorcio ref="dialogRankConsorcio" />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RankConsorcio",

  components: {
    DialogRankConsorcio: () => import("./DialogRankConsorcio")
  },

  data() {
    return {
      headers: [
        { text: "", value: "variacaoConsorcio", sortable: false, align: "end" },
        {
          text: "Posição",
          value: "posicaoConsorcio",
          sortable: false,
          align: "center"
        },
        { text: "Empresa", value: "apelido", sortable: false, align: "center" },
        { text: "Nome", value: "nome", sortable: false, align: "start" },
        {
          text: "Quantidade",
          value: "consorcio",
          sortable: false,
          align: "center"
        }
      ],
      items: []
    };
  },

  computed: {
    ...mapGetters("dashboard", ["getRankConsorcio"]),
    ...mapGetters("dashboard", ["getEmpresas"])
  },

  methods: {
    clearGrafic() {
      this.items = [];
    },

    generateGrafic(rank) {
      for (let i = 0; i < rank.length; i++) {
        const apelido = this.getEmpresas.filter(
          empresa => empresa.cnpj == rank[i].empresa
        )[0].apelido;
        rank[i].apelido = apelido;
      }
      this.items = rank;
    }
  },

  watch: {
    getRankConsorcio(rank) {
      this.clearGrafic();
      this.generateGrafic(rank);
    }
  },

  mounted() {
    if (this.getRankConsorcio.length !== 0) {
      this.clearGrafic();
      this.generateGrafic(this.getRankConsorcio);
    }
  }
};
</script>
